module.exports = __webpack_public_path__ + "static/img/妙保营业执照-总部20260305-图片-0.4fc0850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/妙保营业执照-总部20260305-图片-0.jpg
// module id = bm6M
// module chunks = 1